import { forwardRef } from 'react';
import { PhoneInput as KitPhoneInput } from '@parsina/framework';

import { useTranslation } from '../../i18n';

// The example number inside a sentence is isolated (U+2068 FSI … U+2069 PDI) so an
// ASCII number in a Persian or Arabic message keeps its own direction — the kit
// does the same to its own defaults.
const isolate = (s) => `⁨${s}⁩`;

/**
 * The kit's `PhoneInput`, speaking this panel's language.
 *
 * The kit carries no translation catalogue (packages/DESIGN.md rule 7): its field
 * label, its «کشور» country picker and its five validation messages are Persian
 * defaults a caller is expected to replace. No screen here replaced them, so an
 * English panel showed «کشور» beside every number and answered a short one in
 * Persian. Every screen imports this instead of the kit's, and anything a caller
 * does pass still wins.
 */
function PhoneInputWithCopy({ label, countryLabel, messages, ...props }, ref) {
  const { t } = useTranslation();
  return (
    <KitPhoneInput
      ref={ref}
      label={label === undefined ? t('common.fields.mobileNumber') : label}
      countryLabel={countryLabel ?? t('validation.phone.country')}
      messages={{
        required: t('validation.phone.required'),
        invalid: t('validation.phone.invalid'),
        tooShort: (ctx) => t('validation.phone.tooShort', { country: ctx.countryName, example: isolate(ctx.example) }),
        tooLong: (ctx) => t('validation.phone.tooLong', { country: ctx.countryName, example: isolate(ctx.example) }),
        notMobile: (ctx) => t('validation.phone.notMobile', { example: isolate(ctx.example) }),
        ...messages,
      }}
      {...props}
    />
  );
}

const PhoneInput = forwardRef(PhoneInputWithCopy);

export default PhoneInput;
